// ------------------------------------------------------------------------------
// name: useComputed - 计算属性，只做计算值使用，用于辅助渲染，而不会直接触发渲染
// author: mudas
// created: 2022/9/13
// ------------------------------------------------------------------------------

import { useCreation } from 'ahooks';

export type ComputedHolder<S = any> = () => S;

export function useComputed<S = any>(holder: ComputedHolder<S>, deps?: any[]) {
  return useCreation<S>(holder, deps ?? []);
}
